import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => ({
  tileItem: {
    padding: "0 10px 32px",
    [theme.media.phone]: { padding: "0 6px 24px" }
  },
  card: {
    display: "flex",
    flexDirection: "column",
    gap: 6
  },
  tile: {
    aspectRatio: "1 / 1",
    height: "auto !important",
    minHeight: 140,
    borderRadius: `${theme.tokens.radius.tile}px !important`,
    marginBottom: 6
  }
}));

export default withCustomStyles;
